import React, { useState, useEffect } from "react";
import Moment from "moment";

// Redux
import { connect } from "react-redux";

import PropTypes from "prop-types";
import genericAction from "@Actions/generic";

// Components
import { Label } from "semantic-ui-react";
import IKModal from "@Components/IkModal";
import FilterUI from "@Components/Filter";
import { dropdownFormat } from "@Utils/formats";

// Lodash
import { isEmpty, map, concat, split, find } from "lodash";

// staticData
import {
	contactOption,
	orderByOptions,
	orderByOptionsDetailed,
	etiquetasColumns,
	etiquetasGrupoColumns,
	anioMesColumns,
	noTrabajadasColumns,
	actionsColumns,
} from "./staticData";

// Styles
import styles from "./styles.module.css";

const ActionUserCrud = ({
	onClose,
	dispatch,
	setPlatformfilters,
	groupsfilters,
	setGroupsfilters,
	tagsSelected,
	setTagsSelected,
	startDate,
	setStartDate,
	endDate,
	setEndDate,
	contacts,
	setContacts,
	agents,
	setAgents,
	note,
	setNote,
	options,
	setSeletedFilteres,
	seletedFilteres,
	dateField,
	setDateField,
	onApplyFilters,
	channelFilters,
	setChannelFilters,
	channels,
	setTabValue,
	stateValue,
	setStateValue,
	orderBy,
	setOrderBy,
	orderDirection,
	setOrderDirection,
	actionsSelected = [],
	categoriesSelected = [],
	setCategoriesSelected = () => {},
}) => {
	const [channelfiltersData, setChannelfiltersData] = useState([]);
	const [channelAll, setChannelAll] = useState(false);
	const [groupsAll, setGroupsAll] = useState(false);
	const [groupsData, setGroupsData] = useState([]);
	const [agentsData, setAgentsData] = useState([]);
	const [tagsData, setTagsData] = useState([]);
	const [categoriesData, setCategoriesData] = useState([]);
	const [cleaned, setCleaned] = useState(false);
	const [filtersByReportType, setFiltersByReportType] = useState({});
	const [selectedFilterTemp, setSelectedFilterTemp] = useState(seletedFilteres);
	const [tempOrderBy, setTempOrderBy] = useState(orderBy || "");
	const [tempOrderDirection, setTempOrderDirection] = useState(orderDirection || "");
	const [actionsHistory, setActionsHistory] = useState(actionsSelected);

	const [errors, setErrors] = useState({ platformfilters: "", selected: "" });

	const orderDirectionOptions = (find(orderByOptions, { key: "orderDirection" }) || {}).options || [];

	useEffect(() => {
		(async () => {
			const usersPromise = dispatch(genericAction({ method: "get", route: "users/all" }));
			const tagsPromise = dispatch(genericAction({ method: "get", route: "tags/all" }));
			const groupPromise = dispatch(genericAction({ method: "get", route: "groups/all" }));
			const categoriesPromise = dispatch(genericAction({ method: "get", route: "category/all" }));
			const [usersResponse, tagsResponse, groupResponse, categoriesResponse] = await Promise.all([
				usersPromise,
				tagsPromise,
				groupPromise,
				categoriesPromise,
			]);
			const platoformsMapped = map(channels, (item) => {
				return {
					key: item.id,
					text: `${item.platform.name} - ${item.label.toLowerCase()}`,
					value: item.id,
				};
			});

			const groupsMapped = dropdownFormat(groupResponse, "name", "id");
			const agentsMapped = dropdownFormat(usersResponse, "user.fullName", "userId");
			const tagsMapped = map(tagsResponse, (item) => {
				return {
					key: item.id,
					text: item.name,
					value: item.id,
					categoryId: item.categoryId,
				};
			});
			const categoriesMapped = dropdownFormat(categoriesResponse, "name", "id");
			groupsMapped.unshift({ key: "*", text: "Sin grupo", value: "*" });
			setGroupsData(groupsMapped);

			setChannelfiltersData(platoformsMapped);
			setAgentsData(agentsMapped);
			setTagsData(tagsMapped);
			setCategoriesData(categoriesMapped);
		})();
	}, []);

	const checkAll = (name) => {
		switch (name) {
			case "channelFilters":
				if (!channelAll) {
					const allChannelIds = map(channels, (item) => {
						return item.id;
					});
					setChannelFilters(allChannelIds);
					setChannelAll(true);
				} else {
					setChannelFilters([]);
					setChannelAll(false);
				}
				break;
			case "groupsfilters":
				if (!groupsAll) {
					const allGroupIds = map(groupsData, (item) => {
						return item.value;
					});
					setGroupsfilters(allGroupIds);
					setGroupsAll(true);
				} else {
					setGroupsfilters([]);
					setGroupsAll(false);
				}
				break;
			default:
				break;
		}
	};

	const handleInput = (e) => {
		const { name, value } = e.target;
		if (name === "startDate") {
			setStartDate(value);
		} else {
			setEndDate(value);
		}
	};

	const handleTipyfication = (name, data) => {
		setTagsSelected(data);
	};

	const onFilter = () => {
		const contactId = contacts?.id || null;
		const errorsTest = {};

		const noFieldsSelected =
			isEmpty(agents) &&
			!contactId &&
			isEmpty(groupsfilters) &&
			isEmpty(tagsSelected) &&
			isEmpty(startDate) &&
			isEmpty(endDate) &&
			isEmpty(note) &&
			isEmpty(channelFilters) &&
			isEmpty(selectedFilterTemp) &&
			isEmpty(actionsHistory);

		const onlyReportType =
			!isEmpty(selectedFilterTemp) &&
			isEmpty(agents) &&
			!contactId &&
			isEmpty(groupsfilters) &&
			isEmpty(tagsSelected) &&
			isEmpty(startDate) &&
			isEmpty(endDate) &&
			isEmpty(note) &&
			isEmpty(channelFilters) &&
			isEmpty(actionsHistory);

		if (noFieldsSelected) {
			errorsTest.selected = "Debe seleccionar mínimo un campo";
			setErrors(errorsTest);
			return;
		}

		if (onlyReportType) {
			errorsTest.selected = "Seleccione al menos otro campo además del tipo de reporte";
			setErrors(errorsTest);
			return;
		}

		if (isEmpty(selectedFilterTemp)) {
			errorsTest.selected = "Debe seleccionar un tipo de reporte";
			setErrors(errorsTest);
			return;
		}

		if (tempOrderBy && !tempOrderDirection) {
			errorsTest.selected = "Si selecciona 'Ordenar por', también debe seleccionar 'Ascendente' o 'Descendente'.";
			setErrors(errorsTest);
			return;
		}

		if (
			selectedFilterTemp === "Acciones" &&
			isEmpty(actionsHistory) &&
			isEmpty(agents) &&
			!contactId &&
			isEmpty(channelFilters) &&
			isEmpty(startDate) &&
			isEmpty(endDate)
		) {
			// If actions is empty, we still allow filter if other fields are present,
			// but we follow the general rule of 'at least one field'.
		}

		if (selectedFilterTemp === "Año/Mes") {
			const currentMonth = Moment().format("YYYY-MM");
			if (!startDate) {
				errorsTest.selected = "Debe seleccionar el mes de inicio ('Desde')";
				setErrors(errorsTest);
				return;
			}
			if (!endDate) {
				if (startDate === currentMonth) {
					setEndDate(startDate);
				} else {
					errorsTest.selected = "Debe seleccionar el mes final ('Hasta')";
					setErrors(errorsTest);
					return;
				}
			}
		}

		setErrors({});
		const filters = {};

		if (contactId) filters.contactId = contactId;
		if (!isEmpty(agents)) {
			filters["chat.userId[]"] = concat([], agents);
		}
		if (!isEmpty(groupsfilters)) {
			if (groupsfilters.includes("*")) {
				filters["chat.groupId&*"] = 0;
			} else {
				filters["chat.groupId[]"] = concat([], groupsfilters);
			}
		}

		if (!isEmpty(tagsSelected)) filters["tagId[]"] = tagsSelected;
		if (!isEmpty(categoriesSelected)) filters["tag.categoryId[]"] = categoriesSelected;
		if (note) filters["chat.text"] = note;
		if (!isEmpty(channelFilters)) {
			filters["chat.channelId[]"] = concat([], channelFilters);
		}
		if (selectedFilterTemp === "Acciones" && !isEmpty(actionsHistory)) {
			filters["action[]?"] = actionsHistory;
		}

		if (selectedFilterTemp === "Año/Mes") {
			const key = "date";
			const start = startDate ? startDate.slice(0, 7) : "";
			const end = endDate ? endDate.slice(0, 7) : start;
			filters[key] = `${start},${end}`;
		} else if (selectedFilterTemp === "Etiquetas-Notas") {
			if (startDate) filters.createdDate = startDate;
			if (endDate) filters.closeDate = endDate;
		} else if (dateField && (startDate || endDate)) {
			const start = startDate || "";
			const end = endDate || "";
			let currentDateField = dateField;
			if (selectedFilterTemp === "Etiquetas Combinadas" && dateField === "chat.closeDate") {
				currentDateField = "closeDate";
			} else if (selectedFilterTemp !== "Etiquetas Combinadas" && dateField === "closeDate") {
				currentDateField = "chat.closeDate";
			}
			filters[currentDateField] = `${start},${end}`;
		}
		if (tempOrderBy) {
			filters.orderKey = tempOrderBy;
			if (setOrderBy) setOrderBy(tempOrderBy);
		}
		if (tempOrderDirection) {
			filters.orderDir = tempOrderDirection;
			if (setOrderDirection) setOrderDirection(tempOrderDirection);
		}

		if (selectedFilterTemp === "Resumidas") {
			if (stateValue) filters.state = stateValue;
		}

		setFiltersByReportType((prev) => {
			return {
				...prev,
				[selectedFilterTemp]: filters,
			};
		});

		if (onApplyFilters) {
			setSeletedFilteres(selectedFilterTemp);
			onApplyFilters(filters);
		}
		onClose();
	};

	useEffect(() => {
		const filters = filtersByReportType[selectedFilterTemp];
		if (filters) {
			setAgents(filters["chat.userId[]"] || filters.userId || []);
			setContacts(filters.contactId ? { id: filters.contactId } : {});
			setGroupsfilters(filters["chat.groupId[]"] || filters.groups || []);
			setTagsSelected(filters["tagId[]"] || filters.tags || []);
			setCategoriesSelected(filters["tag.categoryId[]"] || filters["categoryId[]"] || filters.categories || []);
			setNote(filters["chat.text"] || filters.text || "");
			setChannelFilters(filters["chat.channelId[]"] || []);
			setPlatformfilters(filters.platforms || []);

			if (filters.createdDate || filters.closeDate || filters["chat.closeDate"]) {
				const range = filters.createdDate || filters.closeDate || filters["chat.closeDate"];
				const [start, end] = split(range, ",");
				setStartDate(start);
				setEndDate(end);
				setDateField(
					filters.createdDate && !filters.closeDate
						? "createdDate"
						: selectedFilterTemp === "Etiquetas Combinadas"
						? "closeDate"
						: selectedFilterTemp === "Etiquetas-Notas"
						? "createdDate"
						: "chat.closeDate"
				);
			}
		}
	}, [selectedFilterTemp]);

	const onChangeDropdown = (value, name) => {
		if (name === "channelFilters") {
			setChannelFilters(value);
			if (channelfiltersData.length === value.length) {
				setChannelAll(true);
			} else {
				setChannelAll(false);
			}
		} else if (name === "groupsfilters") {
			setGroupsfilters(value);
			if (groupsData.length === value.length) {
				setGroupsAll(true);
			} else {
				setGroupsAll(false);
			}
		}
	};

	const onContactsSelect = (item) => {
		setContacts(item);
	};
	const onContactsRemove = () => {
		setContacts({});
	};
	const renderLabelPlatforms = (label) => {
		return {
			color: "blue",
			content: `${label.text}`,
			icon: label.icon,
		};
	};

	const renderLabelDepartments = (label) => {
		return {
			color: "blue",
			content: `${label.text} `,
			icon: "building outline",
		};
	};
	const cleanModal = () => {
		setAgents([]);
		setContacts("");
		setPlatformfilters([]);
		setChannelFilters([]);
		setGroupsfilters([]);
		setTagsSelected([]);
		setCategoriesSelected([]);
		setStartDate("");
		setEndDate("");
		setNote("");
		setActionsHistory([]);
		setGroupsAll(false);
		setChannelAll(false);
		setErrors({ platformfilters: "", selected: "" });
		setSeletedFilteres("Etiquetas");
		setSelectedFilterTemp("Etiquetas");
		setCleaned(true);

		setTimeout(() => {
			setCleaned(false);
		}, 2000);
	};

	const handleInputDropdown = (event, { value }) => {
		setTagsSelected(value);
	};

	const onChangeSelection = (e, { value }) => {
		setSelectedFilterTemp(value);
		setTempOrderBy("");
		setTempOrderDirection("");
		setTagsSelected([]);
		setCategoriesSelected([]);
		setNote("");
		if (typeof setTabValue === "function") setTabValue("");
		if (typeof setStateValue === "function") setStateValue("");
		if (value === "Año/Mes") {
			setStartDate("");
			setEndDate("");
		} else {
			setStartDate(Moment().format("YYYY-MM-DD"));
			setEndDate("");
		}
	};

	const getFieldsetClass = (filters, data) => {
		const safeFilters = filters || [];
		const safeData = data || [];
		if (isEmpty(safeFilters) && isEmpty(agents) && isEmpty(tagsSelected)) return "";

		const ratio = safeData.length === 0 ? 0 : safeFilters.length / safeData.length;

		if (ratio > 0.75 || !isEmpty(agents) || !isEmpty(tagsSelected)) return styles.hasMostOptions;
		if (ratio > 0.5) return styles.hasManyOptions;

		return styles.hasOptions;
	};
	const getMaxDate = () => {
		return selectedFilterTemp === "Año/Mes" ? Moment().format("YYYY-MM") : Moment().format("YYYY-MM-DD");
	};

	const renderLabelChannels = (label) => {
		return {
			color: "blue",
			content: `${label.text}`,
			icon: label.icon,
		};
	};

	const handleOrderByChange = (value) => {
		setTempOrderBy(value);
		if (value === "createdDate" || value === "closeDate") {
			setDateField(value);
		}
	};

	const getOrderByOptions = () => {
		if (selectedFilterTemp === "Etiquetas")
			return map(etiquetasColumns, (col) => {
				return { key: col.key, text: col.label, value: col.key };
			});
		if (selectedFilterTemp === "Etiquetas Grupo")
			return map(etiquetasGrupoColumns, (col) => {
				return { key: col.key, text: col.label, value: col.key };
			});
		if (selectedFilterTemp === "No Trabajadas")
			return map(noTrabajadasColumns, (col) => {
				return { key: col.key, text: col.label, value: col.key };
			});
		if (selectedFilterTemp === "Año/Mes")
			return map(anioMesColumns, (col) => {
				return { key: col.key, text: col.label, value: col.key };
			});
		if (selectedFilterTemp === "Acciones")
			return map(actionsColumns, (col) => {
				return { key: col.key, text: col.label, value: col.key };
			});
		return map(orderByOptionsDetailed, (col) => {
			return { key: col.key, text: col.text, value: col.value };
		});
	};

	return (
		<IKModal
			iconName="filter"
			title="Filtro de Conv. Generales"
			onClose={onClose}
			onSuccess={onFilter}
			cancelLabel="Cancelar"
			saveLabel="Filtrar"
			fullHeight
			ignoreContent
			size="small">
			<div className={styles.container}>
				{!isEmpty(errors.selected) && (
					<div className={styles.center}>
						<Label basic color="red" pointing="below" className={styles.labelError}>
							{errors.selected}
						</Label>
					</div>
				)}
				<FilterUI
					errors={errors}
					options={options}
					selectedFilterTemp={selectedFilterTemp}
					onChangeSelection={onChangeSelection}
					startDate={startDate}
					endDate={endDate}
					handleInput={handleInput}
					getMaxDate={getMaxDate}
					tempOrderBy={tempOrderBy}
					handleOrderByChange={handleOrderByChange}
					getOrderByOptions={getOrderByOptions}
					orderDirectionOptions={orderDirectionOptions}
					tempOrderDirection={tempOrderDirection}
					setTempOrderDirection={setTempOrderDirection}
					contacts={contacts}
					onContactsSelect={onContactsSelect}
					onContactsRemove={onContactsRemove}
					contactOption={contactOption}
					agents={agents}
					setAgents={setAgents}
					agentsData={agentsData}
					renderLabelPlatforms={renderLabelPlatforms}
					tagsSelected={tagsSelected}
					handleInputDropdown={handleInputDropdown}
					tagsData={tagsData}
					handleTipyfication={handleTipyfication}
					note={note}
					setNote={setNote}
					channelAll={channelAll}
					checkAll={checkAll}
					channelFilters={channelFilters}
					channelfiltersData={channelfiltersData}
					renderLabelChannels={renderLabelChannels}
					groupsData={groupsData}
					groupsAll={groupsAll}
					groupsfilters={groupsfilters}
					onChangeDropdown={onChangeDropdown}
					renderLabelDepartments={renderLabelDepartments}
					cleanModal={cleanModal}
					cleaned={cleaned}
					getFieldsetClass={getFieldsetClass}
					stateValue={stateValue}
					setStateValue={setStateValue}
					actionsHistory={actionsHistory}
					setActionsHistory={setActionsHistory}
					categoriesSelected={categoriesSelected}
					setCategoriesSelected={setCategoriesSelected}
					categoriesData={categoriesData}
					isGeneralReport
				/>
			</div>
		</IKModal>
	);
};

ActionUserCrud.propTypes = {
	onClose: PropTypes.func,
	dispatch: PropTypes.func,
	setPlatformfilters: PropTypes.func,
	groupsfilters: PropTypes.array,
	setGroupsfilters: PropTypes.func,
	tagsSelected: PropTypes.array,
	setTagsSelected: PropTypes.func,
	categoriesSelected: PropTypes.array,
	setCategoriesSelected: PropTypes.func,
	startDate: PropTypes.string,
	setStartDate: PropTypes.func,
	endDate: PropTypes.string,
	setEndDate: PropTypes.func,
	contacts: PropTypes.object,
	setContacts: PropTypes.func,
	agents: PropTypes.array,
	setAgents: PropTypes.func,
	note: PropTypes.string,
	setNote: PropTypes.func,
	options: PropTypes.array,
	setSeletedFilteres: PropTypes.func,
	seletedFilteres: PropTypes.array,
	dateField: PropTypes.string,
	setDateField: PropTypes.func,
	onApplyFilters: PropTypes.func,
	channelFilters: PropTypes.string,
	setChannelFilters: PropTypes.func,
	channels: PropTypes.array,
	stateValue: PropTypes.string,
	setStateValue: PropTypes.func,
	orderBy: PropTypes.string,
	setOrderBy: PropTypes.func,
	orderDirection: PropTypes.string,
	setOrderDirection: PropTypes.func,
	setTabValue: PropTypes.func,
	actionsSelected: PropTypes.array,
};

function mapStateToProps({ chats, company, user }) {
	return {
		reply: chats.reply,
		channels: company.channels,
		user,
	};
}

export default connect(mapStateToProps)(ActionUserCrud);
